import { render, staticRenderFns } from "./CancelCourse.vue?vue&type=template&id=6fbe2a32&"
import script from "./CancelCourse.vue?vue&type=script&lang=js&"
export * from "./CancelCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports